<template>
  <el-dialog
    title="新增录像空间"
    :visible="modalOpen"
    :append-to-body="true"
    width="1000px"
    :before-close="handleModalCancel"
  >
    <div class="add-record-space pagination-table-container">
      <el-table
        ref="table"
        :data="tableData"
        border
        height="400px"
        @selection-change="handleTableSelectionChange"
        style="width: 100%">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column label="本地路径" prop="localPath"></el-table-column>
        <el-table-column label="虚拟路径" prop="virtualPath"></el-table-column>
        <!--<el-table-column label="服务器" prop="serverId"></el-table-column>-->
        <el-table-column label="空间大小(GB)" prop="totalSize">
          <template slot-scope="scope">{{ gByteFromByte(scope.row.totalSize) }}</template>
        </el-table-column>
        <el-table-column label="可用大小(GB)" prop="availableSize">
          <template slot-scope="scope">{{ gByteFromByte(scope.row.availableSize) }}</template>
        </el-table-column>
        <el-table-column label="已用大小(GB)" prop="usedSize">
          <template slot-scope="scope">{{ gByteFromByte(scope.row.usedSize) }}</template>
        </el-table-column>
<!--        <el-table-column label="保留大小(GB)" prop="reservedSize">-->
<!--          <template slot-scope="scope">{{ gByteFromByte(scope.row.reservedSize) }}</template>-->
<!--        </el-table-column>-->
      </el-table>
      <el-pagination
        background
        @current-change="handleTableCurrentChange"
        :current-page.sync="tableQueryParams.pageNum"
        :page-sizes="[5, 10, 20]"
        :page-size="tableQueryParams.pageSize"
        prev-text="上一页"
        next-text="下一页"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotalRow">
      </el-pagination>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleModalSubmit" type="primary">确定</el-button>
      <el-button @click="handleModalCancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import AddRecordSpace from './AddRecordSpace.js'
export default AddRecordSpace
</script>

<style lang="scss">
// @import "AddRecordSpace.scss";
</style>



// WEBPACK FOOTER //
// src/views/system/recordTask/addRecordSpace/AddRecordSpace.vue